var map = {
	"./apple_stock_predictor.png": 4603,
	"./booking_experience.png": 4367,
	"./chatbot.jpg": 4484,
	"./ecommerce.png": 50,
	"./mai_movies.jpeg": 5766,
	"./order_manager.png": 4725,
	"./titanic_challenge.png": 6408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9497;